// 標簽模板列表頁面翻譯
export default {
  // 頁面標題
  title: "標簽模板列表",

  // 按鈕文本
  buttons: {
    addTemplate: "新增標簽模板",
    search: "查詢",
    reset: "重置",
  },

  // 彈窗標題
  dialog: {
    addTemplate: "新增標簽模板",
  },

  // 搜索表單
  search: {
    placeholder: "請輸入查詢標簽名",
    dateRange: {
      startPlaceholder: "開始日期",
      endPlaceholder: "結束日期",
      separator: "→",
    },
  },

  // 表格相關
  table: {
    totalData: "條數據",
    totalPrefix: "共計",
    pagination: {
      itemsPerPage: "條/頁",
      total: "共",
      items: "項",
    },
  },

  // 操作相關
  actions: {
    edit: "編輯",
    delete: "刪除",
    view: "查看",
    copy: "複製",
    download: "下載",
    upload: "上傳",
  },

  // 狀態顯示
  status: {
    public: "是",
    private: "否",
    enabled: "啟用",
    disabled: "禁用",
  },

  // 提示信息
  messages: {
    confirmClose: "確認關閉？",
    deleteConfirm: "確認刪除該標簽模板？",
    deleteSuccess: "刪除成功",
    saveSuccess: "保存成功",
    copySuccess: "複製成功",
    noData: "暫無數據",
    loadError: "加載失敗，請稍後重試",
  },

  // 表單驗證
  validation: {
    nameRequired: "請輸入標簽名稱",
    nameLength: "標簽名稱長度應在2-50個字符之間",
    descriptionRequired: "請輸入標簽描述",
    descriptionLength: "描述長度不能超過200個字符",
  },

  // 表格列標題
  columns: {
    name: "標簽名",
    description: "描述",
    creator: "創建用戶名",
    createTime: "創建時間",
    modifiedTime: "修改時間",
    propertyPublic: "屬性是否公開",
    status: "狀態",
    operations: "操作",
  },

  // 文件上傳相關
  upload: {
    resultTitle: "標簽上傳結果",
    noUpload: "暫無上傳",
    result: "上傳結果",
    batchResultTitle: "標簽批量上傳結果",
  },

  // 批量修改對話框 (alterLabel.vue)
  batchModify: {
    title: "批量修改",
    instruction1:
      "點擊下方下載按鈕，下載當前標簽衝突的所有地址到本地批量修改；",
    instruction2: "點擊下方上傳按鈕，將已修改的文件上傳並同步至平台。",
    downloadBtn: "下 載",
    uploadBtn: "上 傳",
    downloadFileName: "標簽批量下載",
    uploadSuccess: "上傳成功",
    uploadError: "上傳失敗，請刷新頁面重新上傳，或檢查網路",
    uploadErrorTitle: "提示",
    fileTypeError: "只能上傳excel的文件",
  },

  // 新增標簽頁面 (newLabel.vue)
  newLabel: {
    // 表單標簽
    form: {
      labelName: "標簽名稱",
      labelIcon: "標簽圖標",
      labelSort: "標簽排序",
      labelPublicType: "標簽公開類型",
      propertyPublic: "標簽屬性是否公開",
      labelType: "標簽類型",
      addAttribute: "添加標簽屬性",
      canDelete: "標簽是否可以刪除",
    },

    // 表單占位符文本
    placeholders: {
      labelName: "請輸入標簽名稱",
      labelSort: "請輸入標簽排序",
      publicType: "非公開",
      propertyPublic: "是",
      labelType: "請選擇",
      canDelete: "是",
    },

    // 選項文本
    options: {
      public: "公開",
      private: "非公開",
      yes: "是",
      no: "否",
    },

    // 上傳相關
    upload: {
      clickToUpload: "+ 點擊上傳標簽圖標",
      addMultiple: "+ 可添加多個",
    },

    // 提示文本（原CSS偽元素內容）
    hints: {
      iconSize: "標簽圖標尺寸100px*100px,圖片大小不超過1M",
      sortRange: "標簽顯示權重0-9999,數字越小權重越大",
      publicTypeDesc: "公開：所有人可見；非公開：僅自己可見",
      attributeDesc: "給標簽備註屬性字段",
    },

    // 按鈕文本
    buttons: {
      reset: "重置",
      submit: "提交",
    },

    // 驗證消息
    validation: {
      nameRequired: "請輸入標簽名稱",
      iconRequired: "請上傳標簽圖標",
      sortRequired: "請輸入標簽排序",
      publicTypeRequired: "請選擇標簽公開類型",
      propertyPublicRequired: "請選擇標簽屬性是否公開",
      labelTypeRequired: "請選擇標簽類型",
      canDeleteRequired: "請選擇標簽是否可以刪除",
    },

    // 成功消息
    messages: {
      addSuccess: "新增標簽成功",
      uploadError: "上傳失敗，請刷新頁面重新上傳，或檢查網絡",
      uploadErrorTitle: "提示",
    },

    // 標簽屬性子組件 (moreAttributeChild.vue)
    attributeChild: {
      // 表單標簽
      form: {
        attributeName: "屬性名稱",
        required: "是否必填",
        attributeType: "屬性選填類型",
        configureFields: "配置屬性字段",
      },

      // 占位符
      placeholders: {
        attributeName: "請輸入",
        attributeType: "請選擇",
        fieldPlaceholder: "屬性字段",
        fieldTextPlaceholder: "請輸入屬性字段文案",
      },

      // 選項文本
      options: {
        yes: "是",
        no: "否",
        textInput: "文本輸入(手動輸入)",
        enumField: "屬性字段選填(選擇字段)",
      },
    },
  },

  // 標簽結果頁面 (labelResult.vue)
  labelResult: {
    // 標簽上傳統計
    uploadSummary: {
      prefix: "共上傳成功了",
      middle1: "個[",
      middle2: "]標簽的地址,其中有",
      middle3: "個地址已有[",
      middle4: "]標簽,其中字段有衝突的請查看下方表格內容,有",
      suffix: "個上傳失敗的地址。",
    },

    // 標簽頁
    tabs: {
      conflictLabel: "衝突標簽",
      failedLabel: "上傳失敗標簽",
    },

    // 衝突標簽部分
    conflict: {
      batchModifyBtn: "批量修改",
      copySuccess: "複製成功",
      originalAttributes: "原標簽屬性字段",
      newAttributes: "新標簽屬性字段",
      placeholderText: "這裡是新的備註文案",
      mergeBtn: "合併",
      coverBtn: "覆蓋",
      batchMergeBtn: "一鍵合併",
      batchCoverBtn: "一鍵覆蓋",
      conflictTotal: "衝突標簽共",
      conflictTotalSuffix: "個",
      prevBtn: "< 上一條",
      nextBtn: "下一條 >",
    },

    // 失敗標簽部分
    failed: {
      addressColumn: "地址",
      labelNameColumn: "標簽名稱",
      reasonColumn: "失敗原因",
      failedTotal: "上傳失敗標簽共",
      failedTotalSuffix: "頁",
      prevPageBtn: "< 上一頁",
      nextPageBtn: "下一頁 >",
    },

    // 空數據狀態
    empty: {
      text: "暫無數據",
    },

    // 操作結果消息
    operationMessages: {
      mergeSuccess: "標簽合併成功",
      coverSuccess: "標簽覆蓋成功",
      batchMergeSuccess: "一鍵合併成功",
      batchCoverSuccess: "一鍵覆蓋成功",
    },
  },
};
